import * as EventConstants from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import {FromServerDataTableConfig} from 'notebook/data-tables/DataTableConstants';

class DataTableConfigStore extends Store {
  dataTableConfigs!: Array<FromServerDataTableConfig> | null;
  resetState(): void {
    this.dataTableConfigs = null;
  }

  getDataTableConfigs(): Array<FromServerDataTableConfig> | null {
    return this.dataTableConfigs;
  }

  payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.WORKFLOW_ALL_DATA_TABLE_CONFIGS_FETCH_COMPLETED: {
        this.dataTableConfigs = action.dataTableConfigs;
        this.emitChange();
        break;
      }
      default:
        break;
    }
    return true;
  }
}

const dataTableConfigStore = new DataTableConfigStore(AppDispatcher);

export default dataTableConfigStore;
